/*@flow*/
import isNil from './isNil';
import isString from './isString';

export default function isTypeName(name: any): %checks {
  return isNil(name) || isString(name);
}
